export const API_HOST = '/api'
